/**
 * to represent either Document access level is private or public
 */
export enum DocumentAccessLevel {
  Public = "public",
  Private = "private",
}
